import { render, staticRenderFns } from "./fc.vue?vue&type=template&id=ed1cb866&"
import script from "./fc.vue?vue&type=script&lang=js&"
export * from "./fc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports